<template>
  <div>
    <Multiselect
      v-model="value"
      :options="cities"
      :show-labels="false"
      :placeholder="placeholder"
      track-by="name"
      label="name"
      open-direction="bottom"
      :disabled="isDisabled"
    >
      <span slot="caret" class="icon-left">
        <Icon icon-name="map-pin">
          <MapPinIcon></MapPinIcon>
        </Icon>
      </span>
      <span slot="caret" class="arrow">
        <Icon icon-name="modelsCaret" width="16" height="16" direction="up">
          <Arrow></Arrow>
        </Icon>
      </span>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Icon from '@/components/shared/Icons/Icon';
import Arrow from '@/components/shared/Icons/arrow.svg';
import MapPinIcon from '@/components/shared/Icons/map-pin.svg';
export default {
  components: {
    Multiselect,
    Icon,
    MapPinIcon,
    Arrow
  },
  props: {
    cities: { type: Array, default: () => [] },
    placeholder: { type: String },
    selectedCity: { type: Object },
    selectCity: { type: Function, default: () => {} },
    isLoading: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false }
  },
  computed: {
    value: {
      // VUE MULTISELECT DOESNT DISPLAY PLACEHOLDER
      // IF EMPTY VALUE IS !== []
      get() {
        return this.selectedCity && this.selectedCity.id
          ? this.selectedCity
          : [];
      },
      set(city) {
        this.selectCity(city);
      }
    }
  },

  methods: {}
};
</script>
